export default __webpack_public_path__ + "static/media/cars.c2e99fd5.png";